import { IExerciseRecord } from '#pages/DashboardChartForm/types';
import { atom, useRecoilState } from 'recoil';

// 운동기록 생성 api에 사용되는 데이터
// DashboradChartForm records
export const $dashboardCharFormExerciseState = atom<IExerciseRecord[]>({
  key: 'dashboardCharFormExerciseState',
  default: []
});

export const useDashboardCharFormExerciseState = () => {
  const [records, setRecords] = useRecoilState($dashboardCharFormExerciseState);

  return {
    records,
    setRecords
  };
};
